//names from NotificationHubGroups
export enum NotificationGroups {
	RebateLoadStatus = 'RebateLoadStatus',
	RebateLoadFileCreated = 'RebateLoadFileCreated',
	RebateLoadStatistic = 'RebateLoadStatistic',
	RebateLoadMappingSuggested = 'RebateLoadMappingSuggested',
	RebateLoadConversionSuggested = 'RebateLoadConversionSuggested',
	RebatesReSubmissionStatus = 'RebatesReSubmissionStatus',
	RebateSubmissionFileStatus = 'RebateSubmissionFileStatus',
	GeneratedFile = 'GeneratedFile',
	BulkOperationFinished = 'BulkOperationFinished',
	UserTaggedInComment = 'UserTaggedInComment'
}

// names from INotificationHubClientType
export enum NotificationEvents {
	UpdateRebateLoadStatus = 'UpdateRebateLoadStatus',
	RebateLoadFileCreated = 'RebateLoadFileCreated',
	RebateLoadStatisticUpdated = 'RebateLoadStatisticUpdated',
	RebateLoadMappingSuggested = 'RebateLoadMappingSuggested',
	RebateLoadConversionSuggested = 'RebateLoadConversionSuggested',
	UpdateRebatesReSubmissionStatus = 'UpdateRebatesReSubmissionStatus',
	UpdateRebateSubmissionFileStatus = 'UpdateRebateSubmissionFileStatus',
	FileGenerated = 'FileGenerated',
	BulkOperationFinished = 'BulkOperationFinished',
	UserTaggedInComment = 'UserTaggedInComment'
}

export enum HubEvents {
	Subscribe = 'Subscribe',
	UnSubscribe = 'UnSubscribe',
	SubscribeById = 'SubscribeById',
	UnSubscribeById = 'UnSubscribeById'
}
